import AddNodeAttributeModal from './AddNodeAttributeModal';

export default AddNodeAttributeModal;
